import React, { useState, useContext } from 'react';
import axios from 'axios';
import '../styles/Login.css'; // Import CSS file for styling
import logo from '../images/m.png'
import Authcontext from './Auth/Authprovider';
import '../styles/Custombuttons.css'
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { Link } from "react-router-dom";
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import KeyIcon from '@mui/icons-material/Key';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import EmailIcon from '@mui/icons-material/Email';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import * as constants from './Constants'
import Alerts from './Alert';
import Modal from '@mui/material/Modal';
import {  Button } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import image from '../images/logo.png'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

const Register = (props) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [adminEmail, setAdminEmail] = useState('');
  const [adminPassword, setAdminPassword] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [open, setOpen] = useState(false);

  let { loginUser, alertmsg, alertseverity, openalert, setOpenAlert, setAlertMsg, setAlertSeverity } = useContext(Authcontext);

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleRegister = (e) => {
    e.preventDefault();
    // Perform registration logic here using the state values
    const userData = {
      first_name: firstName,
      last_name: lastName,
      admin_email: adminEmail,
      admin_password: adminPassword,
      is_admin: isAdmin,

    };
    let config = {
      method: 'post',
      data:userData, 
      url: `/api/signup/`,
      headers: { 'Authorization': `Bearer ${props.accessToken}` }
    };

    // Make API call to register user
    axios.request(config)
      .then(response => {
        alert('user registered successfully')
        handleClose()

      })
      .catch(error => {
        // Handle registration error
        alert('something went wrong please try later')
        handleClose()
      });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div>
   
      <li className="nav-item" onClick={handleOpen}>
        <a className="nav-link btn btn-outline-warning m-2"><i className="fas fa-plus mx-1"></i> <small className='mx-1'>Create Account </small></a>
      </li>
          
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="login-container d-flex justify-content-center align-items-center">
          <div className=" bg-white d-flex justify-content-center align-items-center" style={{ height: '100vh', width: '50%' }}>
            <form onSubmit={handleRegister} className="text-center text-dark p-3">
              <div>
                <img src={image} alt="Sample image" style={{ width: '160px' }} />
                <h6 className="my-2 p-2 shadow-lg">REGISTER NEW USER</h6>
                <p className="text-center responsive-font my-3" style={{ fontSize: '13px' }}>Enter the new user credentials below </p>

                <Alerts alertseverity={alertseverity} alertmsg={alertmsg} openalert={openalert} setOpenAlert={setOpenAlert} />
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group my-2">
                    <FormControl variant="standard" fullWidth>
                      <InputLabel htmlFor="fname">First Name*</InputLabel>
                      <Input
                        style={{ fontSize: '14px' }}
                        id="fname"
                        name="fname"
                        placeholder="First Name"
                        type='text'
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        startAdornment={<InputAdornment position="start"><PersonIcon /></InputAdornment>}
                        required
                      />
                    </FormControl>
                  </div>
                  <div className="form-group my-2">
                    <FormControl variant="standard" fullWidth>
                      <InputLabel htmlFor="lname">Last Name*</InputLabel>
                      <Input
                        style={{ fontSize: '14px' }}
                        id="lname"
                        name="lname"
                        placeholder="Last Name"
                        type='text'
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        startAdornment={<InputAdornment position="start"><PersonIcon /></InputAdornment>}
                        required
                      />
                    </FormControl>
                  </div>
                  <div className="form-group my-3">
                    <FormControl variant="standard" fullWidth>
                      <InputLabel htmlFor="admin-email">Admin Email*</InputLabel>
                      <Input
                        style={{ fontSize: '14px' }}
                        id="admin-email"
                        name="adminEmail"
                        placeholder="Admin Email"
                        type='email'
                        value={adminEmail}
                        onChange={(e) => setAdminEmail(e.target.value)}
                        startAdornment={<InputAdornment position="start"><EmailIcon /></InputAdornment>}
                        required
                      />
                    </FormControl>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group my-3">
                    <FormControl variant="standard" fullWidth>
                      <InputLabel htmlFor="input-with-icon-adornment">Password*</InputLabel>
                      <Input
                        style={{ fontSize: '14px' }}
                        id="password"
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Admin Password"
                        name="adminPassword"
                        value={adminPassword}
                        onChange={(e) => setAdminPassword(e.target.value)}
                        required
                        startAdornment={<InputAdornment position="start"><KeyIcon /></InputAdornment>}
                        endAdornment={<InputAdornment position="end"><i onClick={togglePassword} className={showPassword ? "fas fa-eye" : "fas fa-eye-slash"} id="togglePassword"></i></InputAdornment>}
                      />
                    </FormControl>
                  </div>
                  <div className="form-group my-3">
                    <FormControl variant="standard" fullWidth>
                      <InputLabel id="is-admin-label">Is Admin</InputLabel>
                      <Select
                        labelId="is-admin-label"
                        id="is-admin"
                        value={isAdmin}
                        onChange={(e) => setIsAdmin(e.target.value)}
                        startAdornment={<InputAdornment position="start"><AdminPanelSettingsIcon /></InputAdornment>}
                      >
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                      </Select>
                      
                    </FormControl>
                  </div>
                </div>
              </div>
              <div className="text-center text-lg-start mt-1 row">
                <div className='col-lg-12 text-center'>
             <Button className='mx-2 my-2' type="submit" variant="contained" color="success">Submit </Button>
                   
                   <Button onClick={handleClose} className='mx-2  my-2' variant="contained" color="warning">Cancel</Button>
                </div>
              </div>
              {/* <div className="text-center text-lg-start mt-1 row">
                <div className='col-lg-12 text-center'>
                <Link to={'/'} style={{ textDecoration: 'none', color: '#2364aa' }}><ButtonComponent type="submit" cssClass='e-custom-warning' className='mb-3 m-2' style={{ textTransform: 'none', fontWeight: 'lighter', width: '40%', padding: '10px' }} disabled={false}> Back to  dashboard</ButtonComponent></Link> 
                </div>
              </div> */}

            </form>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Register;
